import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-roleclaims',
  templateUrl: './roleclaims.component.html'
})
export class RoleClaimsComponent {
  
}